import { TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5 } from '../../../../../config/tables'
import { COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_5, COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_5_TO_PRINT } from './constantesDetalleEspacioPorCerealLinea5'
import { TablaDetalleEspacioPorCerealLinea5Service } from '../../../../../models/movimiento/distribucionEspacioPorCereal/Tabla_detalle_espacio_por_cereal_linea_5'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5
    })
    const promiseTablaDetalleEspacioPorCerealLinea5 = TablaDetalleEspacioPorCerealLinea5Service.getDataTablaDetalleEspacioPorCerealLinea5()
    const promiseTablaDetalleEspacioPorCerealLinea5Total = TablaDetalleEspacioPorCerealLinea5Service.getDataTablaDetalleEspacioPorCerealLinea5Total()
    Promise.all([promiseTablaDetalleEspacioPorCerealLinea5, promiseTablaDetalleEspacioPorCerealLinea5Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Espacio Manipuleo',
        dataCombinada,
        COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_5_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_5,
          data: dataCombinada,
          title: `Espacio Por Cereal Sector 5 Manipuleo`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_5
      })
    }
  }
}
